module.exports = __webpack_public_path__ + "img/LOGO ARTY SYSTEM2.45d697ff.png";